export default {
  IsPayment: 1,
  IsNotPayment: 2,
  ReceiptIsPayment: 3,
  ReceiptIsNotPayment: 4,
};
